import { defineComponent, onMounted, onUpdated, watch } from 'vue';

import Banner from '../banner/Banner.vue';
import BannerCluster from '../banner/cluster/BannerCluster.vue';
import SearchResults from './SearchResults.class';
import StudyCard from '../study-card/StudyCard.vue';
import KeywordHelper from '../keyword-helper/KeywordHelper.vue';
import PreLoader from '../pre-loader/PreLoader.vue';
import Faq from '../faq/Faq.vue';

import { isBannerCluster, isSingleBanner } from './utils';
import NoResultsRecommendations from '../no-results-recommendations/NoResultsRecommendations.vue';

export default defineComponent({
	components: {
		Banner,
		BannerCluster,
		StudyCard,
		KeywordHelper,
		PreLoader,
		NoResultsRecommendations,
		Faq
	},
	setup: () => {
		const component = new SearchResults();

		watch(component.applicationStatus, component.setImpressionTracking.bind(component));
		watch(component.searchResults, component.onSearchUpdate.bind(component));
		onMounted(component.mounted.bind(component));
		onUpdated(component.updated.bind(component));

		return {
			isBannerCluster,
			isSingleBanner,
			isSearchCard: component.isSearchCard.bind(component),
			applicationStatusReady: component.applicationStatusReady,
			noSearchResults: component.noSearchResults,
			searchResults: component.searchResults, // TODO: look into why in this function we get a computed property read only warning
			showSearchHelper: component.showSearchHelper,
			searchResultsRef: component.searchResultsRef,
			isLastPage: component.isLastPage,
			loading: component.loading,
			showRecommendations: component.showRecommendations,
			loadNextPage: component.loadNextPage.bind(component),
			totalResults: component.totalResults,
			amountShown: component.amountShown,
			currentPageNumber: component.currentPageNumber,
			totalPages: component.totalPages,
			onclickPreviousButton: component.onclickPreviousButton.bind(component),
			onclickNextButton: component.onclickNextButton.bind(component),
			isPortalTypeMasters: component.isPortalTypeMasters,
			previousPageHref: component.previousPageHref,
			nextPageHref: component.nextPageHref
		};
	}
});
